// extracted by mini-css-extract-plugin
export default {"container":"AppointmentCard_container__0Muvz","text":"AppointmentCard_text__tBPLn"};